import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <div className="shop__hero">
        <h1>SHOP ALL</h1>
      </div>
       
      <div className="shop__products">
        {productData.map((product) => (
          <Link
            key={product.id}
            to={`/shopDetails/${product.id}`}
            className="shop__product-card"
            onClick={toTop}
          >
            <div className="shop__product-image">
              <img src={product.image} alt={product.name} />
            </div>
            <div className="shop__product-info">
              <h3>{product.name}</h3>
             
              <p className="shop__product-price">${product.price}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Shop;
